import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface RoomType {
  id: number;
  name: string;
}

const fetchRoomTypes = async (): Promise<RoomType[]> => {
  try {
    const { data } = await api.get<RoomType[]>('/api/room-types');
    return data;
  } catch (error) {
    throw new Error('Error al cargar tipos de habitación');
  }
};

export const useRoomTypes = () => {
  const { data: roomTypes = [], isLoading, error } = useQuery({
    queryKey: ['roomTypes'],
    queryFn: fetchRoomTypes,
  });

  return { roomTypes, isLoading, error };
}; 